App.controller('MyPackageCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'packageService', function ($scope, $sce, $state, $http, Config, $mdDialog, packageService) {
    $scope.page = 'mypackage';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Moja deklaracja';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.dashboard';
    $scope.$emit('link', $scope.link);

    // packageService.dataPackageLists().then(function (data) {
    //     $scope.package = $scope.userData.benefit;
    // });

    packageService.dataMyDeclaration().then(function (data) {
        if (data.status === 200) {
            $scope.package = data.data.benefit;
            console.log($scope.package);
            $scope.isActive = ($scope.package.status === 'ACTIVE') ? true : false;
        }
    });
    

    $scope.extend = function() {
        $scope.showPopUp('', '', 'W celu zmiany pakietu na wyższy, prosimy o kontakt z pracodawcą.', 'Ok', '');
    }

    $scope.cancel = function() {
        $scope.showPopUp('', '', 'Niestety nie możesz zrezygnować z pakietu, od terminu rejestracji nie minął wymagany okres 12 miesięcy.', 'Ok', '');
    }

    $scope.showPopUp = function(ev, head, content, text, target) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-small.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function(data) {
            console.log(data);
        }, function() {
            
        });
    }

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide($scope.locals);
        };
    }
}]);